import styled from "@emotion/styled";

export const Title = styled("div")(({ theme }) => ({
    fontSize : "20px"  , 
    fontWeight  : "600" ,
    marginBottom:'20px'

}));
